// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"fc2391c4","355":"ab8a336b","453":"c8cc7b3d"}[chunkId] + ".chunk.js";
};